import {EventEmitter, Injectable, Output} from '@angular/core';
import {CurrentUserDto} from "src/app/models/currentUserDto";
import {HttpClient} from "@angular/common/http";
import jwt_decode from "jwt-decode";
import {MsalService} from "@azure/msal-angular";
import {RegisterService} from "src/app/services/register.service";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  @Output() getLoggedInName: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient,
              private msalService: MsalService,
              private registerservice: RegisterService,
              private router: Router

              ) { }

  /**
   * Decodifica un jwt
   * @param token Token a decodificar
   */
  public getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch (e) {
      return null;
    }
  }

  /**
   * Decodifica un jwt
   */
  public B2CLogin(): any {

    this.msalService.loginPopup().subscribe({
      next:res =>
      {
        setTimeout(() => {
          let loading = document.querySelector('.loading');
          // @ts-ignore
          loading.classList.add('loading--show');
        }, 200);
        //@ts-ignore
        let oid = res.idTokenClaims.oid;
        console.log('id==>', oid)
        this.registerservice.getRoleByIdUser(oid).subscribe(
          resp =>{
            console.log(resp);
            this.registerservice.getCodeVentanillaByIdUser(oid).subscribe(
              resp2 =>{
                this.registerservice.getInfoUserByIdCodeVentanilla(resp2.data).subscribe(
                  resp3 =>{
                  this.registerservice.getIdentificationType().subscribe(respdocumentos => {
                    let filtro = respdocumentos.data.filter((i: { idTipoIdentificacion: string }) => {
                      return (
                        i.idTipoIdentificacion == resp3.data.tipoIdentificacion )
                    });
                    let currentUser:CurrentUserDto;
                    currentUser ={
                      userId: oid,
                      codeVentanilla: resp2.data,
                      rol: resp.data[0].value,
                      fullName: resp3.data.fullName,
                      email: resp3.data.email,
                      documentType: filtro[0].descripcion,
                      documentNumber: resp3.data.numeroIdentificacion,
                    }
                    currentUser = {
                      accessToken: res.idToken,
                      ...currentUser
                    };
                    console.log('currentUser==>',  JSON.stringify(currentUser))
                    localStorage.setItem('currentUser', JSON.stringify(currentUser));
                      localStorage.setItem('Role', currentUser.rol);
                    this.getLoggedInName.emit("true");

                    setTimeout(() => {
                      let loading = document.querySelector('.loading');
                      // @ts-ignore
                      loading.classList.remove('loading--show');
                    }, 200);
                    this.router.navigateByUrl('principal')
                  });
                });
              }
            )
          }
        )
      }
    })
  }

  /**
   * Obtiene el usuario de localstorage
   */
  public getCurrentUser(): CurrentUserDto {
    //@ts-ignore
    return JSON.parse(localStorage.getItem("currentUser"));
  }

  /**
   * Limpia las credenciales del usuario
   */
  public signOutCurrentUser(): void {
    localStorage.clear();
  }

}
